import { useState } from "react"
import { FormInputText } from "../input/form-input-text"
import { FormModal } from "./form-modal"

export interface SystemDetails {
    name: string
    abbreviation: string
    logoUrl: string
    type: string
}

interface AddSystemModalProps {
    onAddSystem: (systemDetails: SystemDetails) => void
    onCloseModal: () => void
    triggerMissingRequiredFields: () => void
    triggerErrorMsg: (txt: string) => void
}

export const AddSystemModal: React.FC<AddSystemModalProps> = (
    { onAddSystem, onCloseModal, triggerMissingRequiredFields, triggerErrorMsg }
) => {
    const [systemDetails, setSystemDetails] = useState<SystemDetails>({ name: '', abbreviation: '', logoUrl: '', type: '' })
    const [isShowSpinner, setIsShowSpinner] = useState(false)

    const onChangeFormValue = (event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
        const { name, value } = event.target
        setSystemDetails({ ...systemDetails, [name]: value })
    }

    const onAdd = async () => {
        if (!systemDetails.name || !systemDetails.abbreviation || !systemDetails.type) {
            return triggerMissingRequiredFields()
        }

        setIsShowSpinner(true)
        try {
            await onAddSystem(systemDetails)
        } catch {
            triggerErrorMsg('Failed creating system')
        }
        finally {
            setIsShowSpinner(false)
        }
    }

    return <FormModal
        header="Create System"
        onCloseModal={onCloseModal}
        actionBtnText="Create"
        onActionBtn={onAdd}
        isShowSpinner={isShowSpinner}
        zIndex={400}
    >
        <div className="form-section-card">
            <div className="field">
                <FormInputText
                    label="Name"
                    keyName="name"
                    isRequired={true}
                    value={systemDetails.name}
                    onChange={onChangeFormValue}
                />
            </div>
            <div className="field">
                <FormInputText
                    label="Abbreviation"
                    keyName="abbreviation"
                    isRequired={true}
                    value={systemDetails.abbreviation}
                    onChange={onChangeFormValue}
                />
            </div>
            <div className="field">
                <FormInputText
                    label="Logo URL"
                    keyName="logoUrl"
                    isRequired={false}
                    value={systemDetails.logoUrl}
                    onChange={onChangeFormValue}
                />
            </div>
            <div className="field">
                <FormInputText
                    label="Type"
                    keyName="type"
                    isRequired={true}
                    value={systemDetails.type}
                    onChange={onChangeFormValue}
                />
            </div>
        </div>
    </FormModal>
}
